export const DEST_PLATE_CODES = {
  96: "TFX96",
  24: "TFX24",
  12: "TFX12",
};
